import { useListResourceGroupsQuery } from '@/queries/resourceGroups.queries';
import IEventType from '@/types/IEventType';
import IResourceGroup from '@/types/IResourceGroup';
import WithQuery from '@/utils/WithQuery';
import SectionResourcesSuccess from './components/SectionResourcesSuccess';

export interface ISectionResourcesProps {
	service: IEventType;
	onChange: (values: Partial<IEventType>) => void;
}

export default WithQuery({
	useHook: function useSectionResources(props: ISectionResourcesProps) {
		const resourceGroupsQuery = useListResourceGroupsQuery();
		return {
			status: resourceGroupsQuery.status,
			props: {
				// SafeCast: We are using WithQuery
				...props,
				resourceGroups: resourceGroupsQuery.data?.resourceGroups as IResourceGroup[],
			},
		};
	},
	Component: SectionResourcesSuccess,
});
